import { LOAD_UPLOAD_INFORMATION_PAGE, UPLOAD_INFORMATION_UPLOAD_BLUEPRINT_FILE } from 'constants/ActionTypes';
import { all, takeLatest } from 'lib/redux';
import { loadUploadInformationSaga, uploadBlueprintFileSaga } from './UploadInformation.saga';

export default function* watchers() {
  yield all([
    takeLatest(LOAD_UPLOAD_INFORMATION_PAGE, loadUploadInformationSaga),
    takeLatest(UPLOAD_INFORMATION_UPLOAD_BLUEPRINT_FILE, uploadBlueprintFileSaga),
  ]);
}
